import { memo } from 'react';
import * as MapSearchUtils from './MapSearchUtils.js';
import { Svg } from '../common/Svg.js';

export const NeedLevelLegend = memo(function () {
    return (
        <div className='need-level-legend'>
            <div className='levels'>
                <div>Lower need<br></br>schools</div>
                <span className='tooltip-wrapper'>
                    <div className={'price-marker ' + MapSearchUtils.NEED_LEVEL_CSS_SELECTORS[1]}>                <div
                        className='school-marker-icon'></div>
</div>
                    <span className='hover-tooltip'><span className='tooltip-arrow'></span>Under a third of students from low-income households</span>
                </span>
                <span className='tooltip-wrapper'>
                    <div className={'price-marker ' + MapSearchUtils.NEED_LEVEL_CSS_SELECTORS[2]}>                <div
                        className='school-marker-icon'></div>
</div>
                    <span className='hover-tooltip'><span className='tooltip-arrow'></span>At least a third of students from low-income households</span>
                </span>
                <span className='tooltip-wrapper'>
                    <div className={'price-marker ' + MapSearchUtils.NEED_LEVEL_CSS_SELECTORS[3]}>                <div
                        className='school-marker-icon'></div>
</div>
                    <span className='hover-tooltip'><span className='tooltip-arrow'></span>At least three-quarters of students from low-income households</span>
                </span>
                <span className='tooltip-wrapper'>
                    <div className={'price-marker ' + MapSearchUtils.NEED_LEVEL_CSS_SELECTORS[4]}>                <div
                        className='school-marker-icon'></div>
</div>
                    <span className='hover-tooltip'><span className='tooltip-arrow'></span>Nearly all students from low-income households</span>
                </span>
                <div>Higher need<br></br>schools</div>
            </div>
        </div>
    );
});
